import Footer from '#app/components/footer.tsx'
import { HeroCarousel } from '#app/components/hero-carousel.tsx'
import AboutProgramSection from '#app/components/programa-madre/about-program-section.tsx'
import ObjectivesSection from '#app/components/programa-madre/objectives-section.tsx'
import OtherProjectsSection from '#app/components/programa-madre/other-projects-section.tsx'
import ProgramComponentsSection from '#app/components/programa-madre/program-components-section.tsx'
import { JoinEffortsSection } from '#app/components/proposito/join-efforts-section.tsx'
import { type Route } from './+types/programa-madre.ts'
import { slidesProgramaMadre } from './config.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Educa ConCiencia | 100prevalor' },
	{
		name: 'description',
		content:
			'Educar, concientizar y actuar frente al Cambio Climático en el ámbito escolar. Programa destinado a estudiantes y docentes de nivel secundario.',
	},
]

export default function ProgramaMadreRoute() {
	return (
		<main className="font-parkinsans">
			{/* Hero Section */}
			<HeroCarousel
				slides={slidesProgramaMadre}
				showIndicators={false}
				showControls={false}
				actionButtonText="Sumarme al proyecto"
			/>

			{/* About Program Section */}
			<AboutProgramSection className="bg-white" />

			{/* Objectives Section */}
			<ObjectivesSection />

			{/* Program Components Section */}
			<ProgramComponentsSection className="bg-white" />

			{/* Other Projects Section */}
			<OtherProjectsSection className="bg-gradient-to-r from-blue-500 to-green-500" />

			{/* Contact Form Section */}
			<JoinEffortsSection title="Vos también podés ser parte del proyecto" />

			{/* Footer */}
			<Footer />
		</main>
	)
}
